import { createSlice } from '@reduxjs/toolkit';
import appapi from '../../api/apiClient';
import { useSelector } from 'react-redux';
import { setNotifyCount, setShipCharterers, setShipMangers, setShipOperators, setShipOwners, setTransactionData } from './layoutSlice';

//Initial State of authslice
const initialState = {
  userId:null,
  user: null,
  companyDetails: null,
  userPermission: null,
  isLoggedIn: false,
  sideMenuList: null,
  showerror: false,
  notifyCount: null
};

const authSlice = createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    //Login
    login(state, action) {
      state.isLoggedIn = true;
      state.userId = action.payload;
    },
    //Logout
    logout(state) {
      // window.grecaptcha.reset();
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      state.isLoggedIn = false;
      state.userId = null;
      state.user = null;
      state.notifyCount = 0;
      state.companyDetails = null;
      state.sideMenuList = null;
    },
    toggleError(state, action) {
      state.showerror = action.payload;
    },
    setCompanyDetails(state, action) {
      state.companyDetails = action.payload;
    },
    setUserPermission(state, action) {
      state.userPermission = action.payload;
    },
    refreshUserData(state, action) {
      state.user = action.payload;
    },
    updateSideMenuList(state, action) {
      state.sideMenuList = action.payload;
    },
  },
});

/**
 * @function initUserData
 * @returns The updated logged In User Data
 */
export const initUserData = () => {
  return async (dispatch, getState) => {
    const { userId } = getState().auth;
    if (userId) {
      const response = await appapi.get(`/user/details`);
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(refreshUserData(data.response));
        }
      }
    }
  };
};

/**
 * @function initCompanyDetails
 * @returns The updated logged In User Data
 */
export const initCompanyDetails = () => {
  return async (dispatch, getState) => {
    const { user } = getState().auth;
    if (user) {
      const response = await appapi.get(`/company-management/companyDetails/${user.companyId}`);
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setCompanyDetails(data.response));
        }
      }
    }
  };
};

export const initTraderDetails = () => {
  return async (dispatch, getState) => {
    const { user } = getState().auth;
    if (user) {
      const response = await appapi.get(`/trader/getTraderdetails/${user.companyId}`);
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(setCompanyDetails(data.response));
        }
      }
    }
  };
};

export const allowEUATrading = (companyDetails) => {

  // if(!companyDetails?.unionRegistryAccount) {
  //   return false;
  // }

  let content = [];
  if(!companyDetails?.regAddress) {
    content.push('Address');
  }
  if(!companyDetails?.countryName) {
    content.push('Country');
  }
  if(!companyDetails?.stateName) {
    content.push('State');
  }
  if(!companyDetails?.companyWebsite) {
    content.push('Website');
  }
  if(!companyDetails?.entityType) {
    content.push('Entity Type');
  }
  if(!companyDetails?.zipCode) {
    content.push('Zip Code');
  }
  if(companyDetails?.documents?.length <= 0) {
    content.push('Certificate of Registry');
    content.push('Audited/Non-Audited Balance sheet');
  } else {
    const cor = companyDetails?.documents?.filter(res => res.certificateName === 'Certificate of Registry')[0]?.attachment;
    if(!cor) {
      content.push('Certificate of Registry');
    }

    const anabs = companyDetails?.documents?.filter(res => res.certificateName === 'Audited/Non-Audited Balance sheet')[0]?.attachment;
    if(!anabs) {
      content.push('Audited/Non-Audited Balance sheet');
    }
  }
  // if(!companyDetails?.euaBalance && companyDetails?.euaBalance != 0) {
  //   return false;
  // }
  // if(!companyDetails?.euaBalanceAttachment) {
  //   return false;
  // }

  if(content.length > 0) {
    return content.join(', ');
  }
  return false;
}

export const checkPermission = (state, moduleName, pageName) => {
  const { permissions } = state.auth?.user;
  if (permissions && permissions.length > 0) {
    const module = (permissions[0]?.modules || []).filter(res => {
      return res.moduleGroup === moduleName
    })[0];
    if (module && module?.permission?.length > 0) {
      const page = (module?.permission || []).filter(res => {
        return res.moduleName === pageName
      })[0]
      if(page) {
        return {
          viewAccess: page.viewAccess === '1',
          editAccess: page.editAccess === '1',
          addAccess: page.addAccess === '1',
          archiveAccess: page.archiveAccess === '1',
        };
      }
    }
  }
  return {
    viewAccess: false,
    editAccess: false,
    addAccess: false,
    archiveAccess: false,
  };
};

export const signOut = () => {
  return async (dispatch, getState) => {
    dispatch(logout());
    dispatch(setShipOwners([]));
    dispatch(setShipMangers([]));
    dispatch(setShipOperators([]));
    dispatch(setShipCharterers([]));
    dispatch(setShipOwners([]));
    dispatch(setNotifyCount([]));
    dispatch(setTransactionData({}));
  };
};

export const { login,logout, refreshUserData,setCompanyDetails,toggleError, updateSideMenuList, setUserPermission } = authSlice.actions;
export default authSlice.reducer;
